import { useQuery } from '@tanstack/react-query';

import { GlobalReactQueryOptions } from '../../config';
import { LineItemCopyOut } from '../../store/api';
import { fetchReserveListItemCopies } from '../../api/reserveLists/fetchReserveListItemCopies';
import { UseQueryResult } from '../../api/query-types';

type UseReserveListItemCopies = UseQueryResult<'copies', ReadonlyArray<LineItemCopyOut>>;

type Options = {
    readonly reserveListId: string;
    readonly productId: string;
    readonly fetchFunc?: typeof fetchReserveListItemCopies;
};

const EMPTY_RESPONSE = { copies: [] };

export const useReserveListItemCopies = ({
    reserveListId,
    productId,
    fetchFunc = fetchReserveListItemCopies
}: Options): UseReserveListItemCopies => {
    const { data: { copies } = EMPTY_RESPONSE, ...result } = useQuery(
        ['getReserveListItemCopies', reserveListId, productId],
        () => fetchFunc(reserveListId, productId),
        { ...GlobalReactQueryOptions }
    );

    return {
        ...result,
        copies
    };
};
